import { render, staticRenderFns } from "./SupplierThing.vue?vue&type=template&id=f2a8af50&"
import script from "./SupplierThing.vue?vue&type=script&lang=ts&"
export * from "./SupplierThing.vue?vue&type=script&lang=ts&"
import style0 from "./SupplierThing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports